import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-test-context=\"1\" ...attributes>{{this.contextText}}</div>",{ moduleName: "filter-wizard/components/display-context.hbs" })